import { AccessControl } from 'accesscontrol';
import type { Query } from 'accesscontrol';
import type { BriefAccessRoleType } from 'bc-model';

type EffectiveAccessType = Query;

const accessControl = new AccessControl();

accessControl
  .grant('reader')
  .create('brief')
  .read('account', ['id', 'name', 'firstName', 'lastName', 'avatarColor'])
  .read('brief', [
    'accountId',
    'effectiveRole',
    'id',
    'key',
    'title',
    'createdAt',
    'createdBy',
    'updatedAt',
    'updatedBy',
  ])
  .read(
    ['brief', 'brief_access', 'date', 'edge', 'history', 'node', 'board', 'rating', 'view'],
    ['*']
  );

accessControl.grant('commenter').extend('reader');

accessControl
  .grant('editor')
  .extend('commenter')
  .create(['date', 'edge', 'node', 'board', 'rating', 'view'])
  .update(['brief', 'date', 'edge', 'node', 'board', 'rating', 'view'])
  .delete(['date', 'edge', 'node', 'board', 'rating', 'view']);

accessControl
  .grant('admin')
  .extend('editor')
  .create('brief_access')
  .update('brief_access')
  .delete('brief_access');

accessControl.grant('owner').extend('admin').delete('brief');

// IF YOU ADD A NEW ACCESS ROLE, IT MUST BE ADDED TO THIS MAP
const queryMap: Record<BriefAccessRoleType, Query> = {
  reader: accessControl.can('reader'),
  commenter: accessControl.can('commenter'),
  editor: accessControl.can('editor'),
  admin: accessControl.can('admin'),
  owner: accessControl.can('owner'),
};

const getAccess = (effectiveRole: BriefAccessRoleType): Query => {
  return queryMap[effectiveRole];
};

accessControl.lock();

export default getAccess;
export type { EffectiveAccessType };
